/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import * as _ from 'lodash';
import {
  buildCountryOptions,
  Country,
  DEFAULT_COUNTRY_PRIO
} from "./countries";

@Component({
  standalone: true,
  selector: 'country-select',
  imports: [CommonModule, FormsModule],
  template: `<select (ngModelChange)="onChange()" class="form-control" style="width:auto" [(ngModel)]="countryModel[countryParam]" [name]="name"><option value=""></option><option *ngFor="let country of countries" [value]="country.code" [disabled]="country.disabled">{{country.name}}</option></select>`
})
export class CountrySelectComponent implements OnInit {
  @Input() countryModel: any;
  @Input() countryParam: any;
  @Input() countryPrio?: Array<string> = DEFAULT_COUNTRY_PRIO;
  @Input() changeHook: () => void;
  @Input() name = '';
  countries: Array<Country>;

  ngOnInit(): void {
    this.countries = buildCountryOptions(this.countryPrio);
  }

  onChange(): void {
    if (_.isFunction(this.changeHook)) {
      this.changeHook();
    }
  }
}
